import {
  IResourceComponentsProps,
  useNavigation,
  useTable,
  useSelect,
  useList,
  useShow,
  useGetIdentity,
  useUpdate,
  useDelete,
  useOne,
  useDeleteMany,
} from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  TableColumnType,
  Space,
  Typography,
  EditButton,
  DeleteButton,
  ShowButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  TagField,
  Progress,
  Menu,
  Tag,
  Form,
  Button,
  Popconfirm,
  message,
  Modal,
  Checkbox,
  Row,
  Col,
  Input,
  Select,
  Badge,
  Divider,
} from '@pankod/refine-antd'
import ReactMarkdown from 'react-markdown'
import { IGrade, IQuestion, IQuestionType, ISubject, ITeacherLevel, IQuestionStatus, ICheckList } from 'interfaces'
import { useEffect, useState } from 'react'
import { TableColumnsType } from 'antd'
import { DraftQuestionFilter } from 'components/filters/draftQuestionFilter'
import metaData from 'metadata/questions'
import { getWorkRequestStatusCount } from 'helpers'
import { ReactMarkdownAllowedElements } from 'helpers/markdownConfig'
import { EditDraftQuestion } from './edit'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import RichTextRender from 'components/questions/rich_text_render'
import { getCount } from 'gql/query'

const { PlusOutlined, MailOutlined, AppstoreOutlined, SettingOutlined, FilterOutlined, DeleteOutlined } = Icons
const { Text, Link } = Typography

interface QuestionListProps extends IResourceComponentsProps {
  request?: any
  updatePercentage?: any
}
type Permission = {
  granted?: boolean
}

const { confirm } = Modal

export const DraftQuestionTableList: React.FC<QuestionListProps> = ({ request, updatePercentage }) => {
  const { userRole } = useUserContext()

  const { data: user } = useGetIdentity()

  const role = user?.defaultRole
  const { show, push } = useNavigation()

  const [currentFilter, setCurrentFilter] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState('')
  const [totalVariantQuestionCount, setTotalVariantQuestionCount] = useState(0)
  const [hasPagination, setHasPagination] = useState<any>(true)

  const { mutate: updateQuestion } = useUpdate()

  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [totalCount, setTotalCount] = useState<number>(0)
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('draft_questions'))
      setCreatePermission(Permissions.can(userRole).createAny('draft_questions'))
      setEditPermission(Permissions.can(userRole).updateAny('draft_questions'))
      setDeletePermission(Permissions.can(userRole).deleteAny('draft_questions'))
    }
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined && userRole !== 'admin' && userRole !== 'qbincharge') push('/')
    console.log(readPermission, 'readpermission')
  }, [readPermission])

  const handleOk = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const showModal = (id: string) => {
    setCurrentRecord(id)
    setIsModalVisible(true)
  }

  const findCount = async () => {
    try {
      const resource = 'draft_questions'
      const responseFindQuestionCount: any = await getCount({ resource })
      let totalCount = responseFindQuestionCount?.forTotalCount?.aggregate?.count
      if (totalCount && totalCount > 0) {
        setTotalCount(totalCount)
      }
    } catch (err) {
      console.log(err, 'error from find count')
    }
  }
  // const [selectedReasons, setSelectedReasons] = useState<string[]>([])
  const [comments, setComments] = useState('')
  var selectedReasons: string[] = []

  const { filters, setFilters, tableQueryResult, sorter, current, setCurrent, pageCount, setPageSize } = useTable<IQuestion>({
    resource: 'questions',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        operator: 'or',
        value: [
          {
            field: 'status',
            operator: 'eq',
            value: 'Draft',
          },
          { field: 'paper_id', operator: 'null', value: false },
        ],
      },
    ],

    metaData,
  })

  // rendering grades. components/questions/DUPLICATE FROM questionsTableList
  const gradeList = useList<IGrade>({
    resource: 'grades',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
    queryOptions: { staleTime: Infinity },
  })
  const renderGrades = (item: any) => {
    let text: object[] = []
    for (let i = 0; i < item?.length; i++) {
      let result = gradeList?.data?.data?.filter((grade: any) => item[i] === grade?.id)[0]
      if (result !== undefined) {
        text.push(<Tag>{result?.name}</Tag>)
      }
    }
    return text
  }

  //This is needed, because varaintcreator needs
  //access to all question in variant question creation

  const { queryResult, setShowId } = useShow<IQuestion>({
    resource: 'questions',
    metaData,
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data

  useEffect(() => {
    if (request?.id !== '' && request?.id !== undefined) {
      setFilters([
        {
          field: 'work_request_id',
          operator: 'eq',
          value: request?.id,
        },
      ])
    }
  }, [request])

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    close: editClose,
    show: editShow,
  } = useModalForm({
    resource: 'questions',
    action: 'edit',
    redirect: false,
    metaData,
  })

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    message.error('Click on No')
  }
  const onChangeReasons = (checkedValues: any[]) => {
    selectedReasons = checkedValues
  }

  const searchByName = (value: any) => {
    setFilters([{ field: 'title', operator: 'contains', value: `%${value}%` }])
  }

  const handleActivateDeactivate = (record: IQuestion) => {
    if (record?.qb_permit) {
      updateQuestion({ id: record?.id!, resource: 'questions', values: { qb_permit: false } })
    } else {
      updateQuestion({ id: record?.id!, resource: 'questions', values: { qb_permit: true } })
    }
  }

  //temp script
  // const engID: any = '5846e9e3-9724-491c-a542-4cde826756f9'
  // const { mutate: deleteTopics } = useDeleteMany()
  // // const { data: subData } = useOne({ id: engID, resource: 'subjects', metaData: { fields: ['id'] } })
  // // console.log('subData', subData?.data)
  // const { tableQueryResult: themeRes } = useTable({
  //   resource: 'themes',
  //   metaData: { fields: ['id'] },
  //   permanentFilter: [{ field: 'subject_id', operator: 'eq', value: engID }],
  //   initialPageSize: 10000,
  // })
  // const themeDataIds: any = themeRes?.data?.data?.map(data => data?.id)
  // const { tableQueryResult: subThemeRes } = useTable({
  //   resource: 'sub_themes',
  //   metaData: { fields: ['id'] },
  //   permanentFilter: [{ field: 'theme_id', operator: 'in', value: themeDataIds }],
  //   queryOptions: { enabled: !!themeDataIds },
  //   initialPageSize: 10000,
  // })
  // const subThemeDataIds: any = subThemeRes?.data?.data?.map(data => data?.id)
  // const { tableQueryResult: topicRes } = useTable({
  //   resource: 'topics',
  //   metaData: { fields: ['id', 'name'] },
  //   permanentFilter: [{ field: 'sub_theme_id', operator: 'in', value: subThemeDataIds }],
  //   queryOptions: { enabled: !!subThemeDataIds },
  //   initialPageSize: 10000,
  // })
  // const topicIds: any = topicRes?.data?.data?.map(data => data?.id)

  // console.log('subtheme', topicRes?.data?.data)

  const changeFilters = (field: string, value: string, operator: any) => {
    if (field !== 'all') {
      if (currentFilter === 'status') {
        filters.pop()
      }
      setFilters([
        {
          field: field,
          operator: operator,
          value: value,
        },
      ])
    } else if (field === 'all') {
      filters.splice(0, filters.length)
      if (request?.id !== '') {
        setFilters([
          {
            field: 'work_request_id',
            operator: 'eq',
            value: request?.id,
          },
        ])
      }
    }
    if (user && userRole === 'variantcreator') {
      setFilters([
        {
          field: 'creator_id',
          operator: 'eq',
          value: user?.id,
        },
      ])
    }
    setCurrentFilter(field)
  }

  useEffect(() => {
    if (userRole !== undefined && userRole !== '' && userRole !== null) {
      if (userRole === 'qreviewer') {
        setFilters([{ field: 'reviewer_id', operator: 'eq', value: user?.id }], 'replace')
      } else if (userRole === 'qapprover') {
        setFilters([{ field: 'approver_id', operator: 'eq', value: user?.id }], 'replace')
      } else if (userRole === 'papersetter') {
        setFilters([{ field: 'creator_id', operator: 'eq', value: user?.id }], 'replace')
      }
    }
    findCount()
  }, [userRole])

  const columns: TableColumnsType<IQuestion> = [
    {
      dataIndex: 'question_id',
      title: 'Id',
    },

    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, record) => (
        <ShowButton
          size="small"
          type="link"
          icon={null}
          recordItemId={record?.id}
          onClick={() => {
            show('questions', record?.id)
          }}
        >
          <Text
            style={{
              width: 200,
              textAlign: 'left',
              color: '#6659FF',
              cursor: 'pointer',
            }}
            ellipsis={{ tooltip: record?.title }}
          >
            {/* <ReactMarkdown
              allowedElements={ReactMarkdownAllowedElements}
              components={{
                p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
              }}
            >
              {record?.title.length < 30 ? record?.title.substring(0, 30) : record?.title.substring(0, 30).concat('...')}
            </ReactMarkdown> */}
            <RichTextRender content={record?.title ?? ''} />
          </Text>
        </ShowButton>
      ),
    },
    {
      dataIndex: 'question_type_id',
      title: 'Q Type',
    },
    {
      dataIndex: 'grade_ids',
      title: 'Grade',
      render: (_, { question_grades, grade_ids }) => (
        <>
          {question_grades?.length > 0 ? (
            <div>
              {question_grades?.length > 1 ? (
                <Badge size="small" count={question_grades?.length - 1} style={{ background: '#6659ff' }}>
                  {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                  <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                    {question_grades?.[0]?.grade?.name}
                  </Tag>
                  {/* </Tooltip> */}
                </Badge>
              ) : (
                <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                  {question_grades[0]?.grade?.name}
                </Tag>
              )}
            </div>
          ) : null}
        </>
      ),
    },
    {
      dataIndex: 'topic_id',
      title: 'Topic',
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.topic?.name }}>
          {record?.topic?.name}
        </Text>
      ),
    },
    // {
    //   dataIndex: 'due_date',
    //   title: 'Due Date',
    //   render: value => (
    //     <div style={{ width: 80, textAlign: 'left' }}>
    //       <DateField format="DD-MMM-YY" value={value} />
    //     </div>
    //   ),
    // },
    {
      dataIndex: 'status',
      title: 'Status',
      width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag
          color={
            value === 'Published'
              ? 'green'
              : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
              ? 'volcano'
              : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'qb_permit',
      title: 'QB Edit',
      render: (value, record) => <Tag color={value ? 'green' : 'volcano'}>{value ? 'Enabled' : 'Disabled'}</Tag>,
    },
    {
      dataIndex: 'creator_id',
      title: 'Creator',

      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
          {record?.userByCreatorId?.displayName}
        </Text>
      ),
    },
    // {
    //   dataIndex: 'reviewer_id',
    //   title: 'Reviewer',
    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByReviewerId?.displayName }}>
    //       {record?.userByReviewerId?.displayName}
    //     </Text>
    //   ),
    // },
    // {
    //   dataIndex: 'approver_id',
    //   title: 'Approver',
    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByApproverId?.displayName }}>
    //       {record?.userByApproverId?.displayName}
    //     </Text>
    //   ),
    // },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          {/* {userRole === 'admin' ||
          (userRole === 'qcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
          (userRole === 'qreviewer' && (record?.status === 'For Review' || record?.status === 'For Review (Require Amending)')) ||
          (userRole === 'qapprover' && record?.status === 'For Approval') ? (
            <EditButton
              key="edit"
              size="small"
              type="link"
              hideText
              recordItemId={record.id}
              onClick={() => {
                editShow(record?.id)
                setShowId(record?.id)
              }}
            />
          ) : null} */}
          {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
            <Button type="primary" onClick={() => showModal(record?.id)}>
              Mark Retired
            </Button>
          ) : null}
          {/* {userRole === 'admin' || (userRole === 'qcreator' && record?.status === 'Open') ? (
            <DeleteButton key="delete" size="small" type="link" hideText resourceName={'questions'} recordItemId={record.id} />
          ) : null} */}
          {(userRole === 'qbincharge' || userRole === 'admin') && record?.status !== 'Retired' && record?.qb_permit === true ? (
            <Button
              danger
              size="small"
              onClick={() => {
                handleActivateDeactivate(record)
              }}
            >
              Disable
            </Button>
          ) : (userRole === 'qbincharge' || userRole === 'admin') && record?.status !== 'Retired' && record?.qb_permit === false ? (
            <Button
              size="small"
              style={{ color: 'green', borderColor: 'green' }}
              onClick={() => {
                handleActivateDeactivate(record)
              }}
            >
              Enable
            </Button>
          ) : null}
        </Space>
      ),
    },
  ]
  const onChange = (page: number, pageSize?: any): void => {
    setPageSize(pageSize)
    setCurrent(page)
  }

  // const { total_valid_questions } = getWorkRequestStatusCount(request)

  useEffect(() => {
    if (request?.request_type === 'V') {
      let _totalVariantQuestionCount = 0
      request?.variant_options?.forEach((item: any) => {
        _totalVariantQuestionCount = _totalVariantQuestionCount + JSON.parse(item?.variant_count)
      })
      setTotalVariantQuestionCount(_totalVariantQuestionCount)
    }
  }, [request])

  return (
    <List
      title="Draft Questions"
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton key="refresh" onClick={() => tableQueryResult?.refetch()} />,
        ],
      }}
    >
      <Divider />
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={6}>
          <div
            style={{
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
              padding: '1rem',
              height: '4rem',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <h4>
              Total Draft Questions:
              <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}> {totalCount}</span>
            </h4>
          </div>
        </Col>
      </Row>
      <Divider />
      <DraftQuestionFilter changeFilters={changeFilters} source={'Questions'} />
      <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      />
      <Divider />
      <Table
        size="small"
        dataSource={tableQueryResult?.data?.data}
        columns={columns}
        loading={tableQueryResult?.isLoading}
        pagination={{
          total: tableQueryResult?.data?.total,
          onChange,
        }}
        scroll={{ x: 600 }}
      />
      <EditDraftQuestion
        modalProps={editModalProps}
        formProps={editFormProps}
        record={record}
        close={editClose}
        updatePercentage={updatePercentage}
      />
    </List>
  )
}
